<template>
	<div class="my-custom-select" :class="{'my-custom-select-active': toggleActiveClass, 'input-error': inputError}">
		<select>
			<option>{{placeholder}}</option>
			<option v-for="option in options">{{option.title}}</option>
		</select>
	</div>
</template>

<script>
	export default {
		name: 'SelectBox',
		props: ['options', 'placeholder', 'inputError'],
		data() {
			return {
				selectedOption: '',
				toggleActiveClass: false
			}
		},
		mounted() {
			let that = this;
			let x, i, j, selElmnt, a, b, c;
			/*look for any elements with the class "my-custom-select":*/
			x = document.getElementsByClassName("my-custom-select");
			for (i = 0; i < x.length; i++) {
				selElmnt = x[i].getElementsByTagName("select")[0];
				/*for each element, create a new DIV that will act as the selected item:*/
				a = document.createElement("DIV");
				a.setAttribute("class", "select-selected");
				a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
				x[i].appendChild(a);
				/*for each element, create a new DIV that will contain the option list:*/
				b = document.createElement("DIV");
				b.setAttribute("class", "select-items select-hide");
				for (j = 1; j < selElmnt.length; j++) {
					/*for each option in the original select element,
					create a new DIV that will act as an option item:*/
					c = document.createElement("DIV");
					c.innerHTML = selElmnt.options[j].innerHTML;
					c.addEventListener("click", function(e) {
						/*when an item is clicked, update the original select box,
						and the selected item:*/
						let y, i, k, s, h;
						s = this.parentNode.parentNode.getElementsByTagName("select")[0];
						h = this.parentNode.previousSibling;
						for (i = 0; i < s.length; i++) {
							if (s.options[i].innerHTML == this.innerHTML) {
								s.selectedIndex = i;
								h.innerHTML = this.innerHTML;
								y = this.parentNode.getElementsByClassName("same-as-selected");
								/* emit event when option is selected*/
								that.$emit('change', i-1);
								for (k = 0; k < y.length; k++) {
									y[k].removeAttribute("class");
								}
								this.setAttribute("class", "same-as-selected");
								break;
							}
						}
						h.click();
					});
					b.appendChild(c);
				}
				x[i].appendChild(b);
				a.addEventListener("click", function(e) {
					/*when the select box is clicked, close any other select boxes,
					and open/close the current select box:*/
					e.stopPropagation();
					closeAllSelect(this);
					this.nextSibling.classList.toggle("select-hide");
					this.classList.toggle("select-arrow-active");
					that.toggleActiveClass = !that.toggleActiveClass;
				});
			}
			function closeAllSelect(elmnt) {
				/*a function that will close all select boxes in the document,
				except the current select box:*/
				let x, y, i, arrNo = [];
				x = document.getElementsByClassName("select-items");
				y = document.getElementsByClassName("select-selected");
				for (i = 0; i < y.length; i++) {
					if (elmnt == y[i]) {
						arrNo.push(i)
					} else {
						y[i].classList.remove("select-arrow-active");
					}
				}
				for (i = 0; i < x.length; i++) {
					if (arrNo.indexOf(i)) {
						x[i].classList.add("select-hide");
					}
				}
			}

			/*if the user clicks anywhere outside the select box,
			then close all select boxes:*/
			document.addEventListener("click", closeAllSelect);
		}
	}
</script>

<style>
	.my-custom-select {
		position: relative;
		font-family: inherit;
		width: 100%;
		height: 100%;
		border: 1px solid #f2f2f2;
		border-radius: 4px;
		margin: auto;
	}

	.my-custom-select.my-custom-select-active {
		border-bottom-right-radius: 0;
		border-bottom-left-radius: 0;
		box-shadow: 0 0 0 3px rgba(92, 193, 166, .5);
	}

	.my-custom-select select {
		display: none;
	}

	.select-selected {
		background-color: #292b31;
		border-radius: 4px;
	}

	.select-selected:after {
		position: absolute;
		content: "";
		top: 12px;
		right: 12px;
		width: 0;
		height: 0;
		border: solid white;
		border-width: 0 3px 3px 0;
		padding: 4px;
		transform-origin: center center;
		transform: rotate(45deg);
		-webkit-transform: rotate(45deg);
		-webkit-transition: transform .25s;
		transition: transform .25s;
	}

	.select-selected.select-arrow-active:after {
		transform: rotate(-135deg);
		-webkit-transform: rotate(-135deg);
		top: 17px;
		-webkit-transition: transform .25s;
		transition: transform .25s;
	}

	.select-items div,.select-selected {
		color: #ffffff;
		padding: 8px 16px;
		border: 1px solid transparent;
		border-color: transparent transparent rgba(0, 0, 0, 0.1) transparent;
		cursor: pointer;
		user-select: none;
	}

	.select-items {
		position: absolute;
		background-color: #292b31;
		top: 100%;
		left: 0;
		right: 0;
		z-index: 99;
		border: 1px solid #f2f2f2;
		border-bottom-left-radius: 4px;
		border-bottom-right-radius: 4px;
		box-shadow: 0 0 0 3px rgba(92, 193, 166, .5);
	}

	.select-hide {
		display: none;
	}

	.select-items div:hover, .same-as-selected {
		background-color: rgba(255,255,255, 0.1);
	}
</style>